import { format, subDays } from 'date-fns';

const today = new Date();

export const users = [
  {
    id: 'usr-admin',
    name: 'Administrador',
    email: 'admin@kotaplus.cl',
    password: 'admin123',
    role: 'super_user',
    profile: 'super_user',
    avatar: 'AD',
    department: 'Administración',
    phone: '',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['*'],
    allowedPages: null
  },
  // Usuarios demo por cargo (clave común admin123)
  {
    id: 'usr-1',
    name: 'Comprador',
    email: 'comprador@kotaplus.cl',
    password: 'admin123',
    role: 'comprador',
    profile: 'operativo',
    avatar: 'CO',
    department: 'Abastecimiento',
    phone: '+56 9 4567 1234',
    lastLogin: format(subDays(today, 1), 'yyyy-MM-dd'),
    permissions: ['orders:create', 'orders:view', 'inventory:view', 'shipments:request']
  },
  {
    id: 'usr-2',
    name: 'Jefe de Proyecto',
    email: 'pm@kotaplus.cl',
    password: 'admin123',
    role: 'project_manager',
    profile: 'gerente',
    avatar: 'JP',
    department: 'Gestión de Proyectos',
    phone: '+56 9 7766 5544',
    lastLogin: format(subDays(today, 2), 'yyyy-MM-dd'),
    permissions: ['orders:view', 'orders:approve:project', 'budget:own']
  },
  {
    id: 'usr-3',
    name: 'Gerente de Área',
    email: 'area@kotaplus.cl',
    password: 'admin123',
    role: 'area_manager',
    profile: 'gerente',
    avatar: 'GA',
    department: 'Operaciones Campo',
    phone: '+56 9 6677 2211',
    lastLogin: format(subDays(today, 1), 'yyyy-MM-dd'),
    permissions: ['orders:view', 'orders:approve:area', 'inventory:view']
  },
  {
    id: 'usr-4',
    name: 'Director de Proyectos',
    email: 'aprobador@kotaplus.cl',
    password: 'admin123',
    role: 'project_director',
    profile: 'director',
    avatar: 'DP',
    department: 'Dirección de Proyectos',
    phone: '+56 9 9987 4567',
    lastLogin: format(subDays(today, 3), 'yyyy-MM-dd'),
    permissions: ['parks:manage', 'orders:view']
  },
  {
    id: 'usr-5',
    name: 'Gerente de Área Suplente',
    email: 'area.manager@kotaplus.cl',
    password: 'admin123',
    role: 'area_manager',
    profile: 'gerente',
    avatar: 'GS',
    department: 'Operaciones Campo',
    phone: '+56 9 8899 3322',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['orders:approve:area', 'inventory:view']
  },
  {
    id: 'usr-6',
    name: 'Técnico de Terreno',
    email: 'tecnico@kotaplus.cl',
    password: 'admin123',
    role: 'field_technician',
    profile: 'operativo',
    avatar: 'TT',
    department: 'Operaciones Campo',
    phone: '+56 9 3344 5566',
    lastLogin: format(subDays(today, 1), 'yyyy-MM-dd'),
    permissions: ['requisitions:create', 'inventory:view']
  },
  {
    id: 'usr-7',
    name: 'Controller de Compras',
    email: 'controller@kotaplus.cl',
    password: 'admin123',
    role: 'purchase_controller',
    profile: 'gerente',
    avatar: 'CC',
    department: 'Abastecimiento',
    phone: '+56 9 1122 3344',
    lastLogin: format(subDays(today, 2), 'yyyy-MM-dd'),
    permissions: ['requisitions:review', 'orders:assign']
  },
  {
    id: 'usr-8',
    name: 'Gerente de Compras',
    email: 'gerente.compras@kotaplus.cl',
    password: 'admin123',
    role: 'purchasing_manager',
    profile: 'director',
    avatar: 'GC',
    department: 'Abastecimiento',
    phone: '+56 9 7788 9900',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['orders:approve:management', 'requisitions:view']
  },
  {
    id: 'usr-9',
    name: 'Técnico de Terreno Demo',
    email: 'demo.tecnico@kotaplus.cl',
    password: 'admin123',
    role: 'field_technician',
    profile: 'operativo',
    avatar: 'TD',
    department: 'Operaciones Campo',
    phone: '+56 9 1234 5678',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['requisitions:create', 'inventory:view']
  },
  {
    id: 'usr-10',
    name: 'Administrativo',
    email: 'demo.administrativo@kotaplus.cl',
    password: 'admin123',
    role: 'office_staff',
    profile: 'operativo',
    avatar: 'AD',
    department: 'Administración',
    phone: '+56 9 8765 4321',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['requisitions:create', 'orders:view']
  },
  {
    id: 'usr-11',
    name: 'Gerente de Contratos',
    email: 'contract.manager@kotaplus.cl',
    password: 'admin123',
    role: 'contract_manager',
    profile: 'gerente',
    avatar: 'GT',
    department: 'Legal & Contratos',
    phone: '+56 9 6543 2109',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: ['suppliers:review', 'suppliers:approve', 'suppliers:documents']
  },
  {
    id: 'usr-12',
    name: 'Super Usuario',
    email: 'super.user@kotaplus.cl',
    password: 'admin123',
    role: 'super_user',
    profile: 'super_user',
    avatar: 'SU',
    department: 'Gobernanza ERP',
    phone: '+56 9 5412 7788',
    lastLogin: format(subDays(today, 1), 'yyyy-MM-dd'),
    permissions: [
      'system:manage_roles',
      'orders:view',
      'orders:approve:management',
      'requisitions:route',
      'parks:manage',
      'cost_centers:manage',
      'hierarchy:configure',
      'tasks:assign'
    ]
  },
  {
    id: 'usr-17',
    name: 'Abogado Jefe',
    email: 'abogado.jefe@kotaplus.cl',
    password: 'admin123',
    role: 'abogado',
    profile: 'gerente',
    avatar: 'AJ',
    department: 'Área Legal',
    phone: '+56 9 7788 1199',
    lastLogin: format(today, 'yyyy-MM-dd'),
    permissions: [
      'legal:cases',
      'legal:contracts',
      'legal:compliance',
      'legal:documents',
      'legal:reports'
    ]
  },
  {
    id: 'usr-18',
    name: 'Abogado Asociado',
    email: 'asociado.legal@kotaplus.cl',
    password: 'admin123',
    role: 'abogado',
    profile: 'gerente',
    avatar: 'AA',
    department: 'Área Legal',
    phone: '+56 9 6655 4477',
    lastLogin: format(subDays(today, 2), 'yyyy-MM-dd'),
    permissions: ['legal:cases', 'legal:documents']
  }
];

export const locations = [
  { id: 'loc-1', name: 'Bodega Central', code: 'BC-01', address: '—', type: 'bodega' }
];
export const inventory = [];
export const purchaseOrders = [];
export const purchaseRequisitions = [];
export const shipments = [];
export const movements = [];
export const suppliers = [];
export const notifications = [];
export const auditLog = [];
export const costCenters = [];
export const parks = [];
export const categories = [];
export const projectBudgets = [];
export const projectTimelines = [];
export const tenders = [];
export const lawyers = [];
export const legalCases = [];
export const legalContracts = [];
export const legalComplianceMatrix = [];
export const legalDocuments = [];
export const legalPowers = [];
export const legalReports = [];
export const rfqs = [];

export const apiEndpoints = [
  {
    id: 'api-1',
    title: 'Healthcheck',
    method: 'GET',
    route: '/health',
    description: 'Verifica estado del servicio (demo).'
  }
];
